<template>
    <p class="field" :class="{ 'invalid': isInvalid }">
        <label :for="label">{{ fullLabel }}</label>
        <slot />
        <span v-if="isInvalid" class="invalid_help">
            {{ error.msg }}
        </span>
    </p>
</template>

<script>
export default {
    name: 'app-settings-select',
    props: {
        label: {
            type: String,
            default: ''
        },
        error: {
            type: Object,
            default() {
                return {}
            }
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        fullLabel() {
            return this.label + (this.required ? ' *' : '')
        },
        isInvalid() {
            return 'field' in this.error
        }
    }
}
</script>